import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";

import { ReserveProvider } from "@/components/boost/ReserveContext";
import Home from "@/pages/Home";
import ThankYou from "@/pages/ThankYou";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import RefundPolicy from "@/pages/RefundPolicy";
import NotFound from "@/pages/NotFound";
import BusinessResults from "@/pages/BusinessResults";
import MentorLogin from "@/pages/MentorLogin";
import MentorDashboard from "@/pages/MentorDashboard";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ReserveProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/results" element={<BusinessResults />} />
            <Route path="/mentor/login" element={<MentorLogin />} />
            <Route path="/mentor/dashboard" element={<MentorDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </ReserveProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
